import staticData from "../../data/contact-data";
import createAxiosClient from "../../clients/axiosClient";

const getSolutionStaticDataOnError = (err, solutionTag) => {
  console.warn(err, `Failed getting solution contact details by tag ${solutionTag}`);
  console.log("Trying to return static data for ", solutionTag);
  return staticData[solutionTag];
};

export const getSolutionContactDetails = async location => {
  const locationElements = location.split(" | ");
  locationElements.shift();
  const solutionTag = locationElements.join("-");
  try {
    const helpUiAxiosClient = await createAxiosClient();
    const response = await helpUiAxiosClient.get(
      `${process.env.NEXT_PUBLIC_API_DOMAIN}/customer-help/contact-channel-manager/v1/contact/solution/${solutionTag}`,
    );
    return response.data;
  } catch (err) {
    return getSolutionStaticDataOnError(err, solutionTag);
  }
};

export const getSolutionContactDetailsByTag = async solutionTag => {
  try {
    const helpUiAxiosClient = await createAxiosClient();
    const response = await helpUiAxiosClient.get(
      `${process.env.NEXT_PUBLIC_API_DOMAIN}/customer-help/contact-channel-manager/v1/contact/solution/${solutionTag}`,
    );
    return response.data;
  } catch (err) {
    return getSolutionStaticDataOnError(err, solutionTag);
  }
};

export const getOtherAreasContactDetails = async () => {
  try {
    const helpUiAxiosClient = await createAxiosClient();
    const response = await helpUiAxiosClient.get(
      `${process.env.NEXT_PUBLIC_API_DOMAIN}/customer-help/contact-channel-manager/v1/contact/other`,
    );
    return response.data;
  } catch (err) {
    return getSolutionStaticDataOnError(err, "other-areas");
  }
};
